module.exports = __webpack_public_path__ + "img/1.f0f828d9.jpg";